// Date 2021-09-28 15:21:04

import mintalMesMstMaterial from "@/store/mintalMes/mst/MintalMesMstMaterialStore.js";
import mintalMesMstEquipment from "@/store/mintalMes/mst/MintalMesMstEquipmentStore.js";
import mintalMesMstEnergy from "@/store/mintalMes/mst/MintalMesMstEnergyStore.js";
import mintalMesMstFurnace from "@/store/mintalMes/mst/MintalMesMstFurnaceStore.js";
import mintalMesMstWarehouse from "@/store/mintalMes/mst/MintalMesMstWarehouseStore.js";
import mintalMesMstPowerStationMeter from "@/store/mintalMes/mst/MintalMesMstPowerStationMeterStore.js";
import mintalMesMstSubstationPoint from "@/store/mintalMes/mst/MintalMesMstSubstationPointStore.js";
import mintalMesMstGeneratorSet from "@/store/mintalMes/mst/MintalMesMstGeneratorSetStore.js";

const genericEntities = [
    'mintalMesMstMaterial',
    'mintalMesMstEquipment',
    'mintalMesMstEnergy',
    'mintalMesMstFurnace',
    'mintalMesMstWarehouse',
    'mintalMesMstPowerStationMeter',
    'mintalMesMstSubstationPoint',
    'mintalMesMstGeneratorSet'
]

const entities = {
    mintalMesMstMaterial,
    mintalMesMstEquipment,
    mintalMesMstEnergy,
    mintalMesMstFurnace,
    mintalMesMstWarehouse,
    mintalMesMstPowerStationMeter,
    mintalMesMstSubstationPoint,
    mintalMesMstGeneratorSet
}

export {genericEntities}

export default entities